import React, { useState, useEffect, useRef } from "react";

function AddressCheckbox(props) {
  const {
    label,
    name,
    id,
    fieldId,
    isRequired,
    errId,
    divClass,
    options,
    checkDetailsIndex,
    fieldName,
    handleCheckboxChange,
    fieldValue,
    disabled,
  } = props;

  const [checked, setChecked] = React.useState(false);

  console.log("till",fieldValue,name)


  useEffect(() => {

    

    if (fieldValue != "") {

     // console.log("till123",fieldValue);
     //   let name = `selectedOption_add_${caseCheckId}`;
     //   setChecked(1);
     setChecked(true);
    }else{
      setChecked(false);
    }

    // setFormData((prevState) => ({
    //     ...prevState,
    //     [name]: value,
    // }));

}, [fieldValue]);


  const handleOnChange = (e) => {
  

   // console.log("check "+e.target.checked);
    setChecked(e.target.checked);

    handleCheckboxChange([{ "name": name, "value": e.target.checked, "fieldId": fieldId, "isRequired": isRequired, "err_id": `err-${fieldId}`, "checkdetailsindex": checkDetailsIndex, "fieldname": fieldName  }]);
    
   // handleCheckboxChange(e.target);

  };
  return (
    <>
      <div className="col-sm-4 col-md-12 col-xl-4 d-inline-flex align-items-center">
        <div className="form-group">
          <div className="form-check">
            <input
              key={`${name}_checkbox`}
              type="checkbox"
              className="form-check-input"
              name={name}
              id={id}
              onChange={(e) => handleOnChange(e)}
              data-checkdetailsindex={checkDetailsIndex}
              data-fieldname={fieldName}
              checked={checked ? true : false}
              disabled={disabled}
            />
            <label htmlFor={name} className="form-check-label">
              {label}
              {isRequired == 1 && <sup className="text-danger">*</sup>}
            </label>
            <p className="err text-danger" id={errId}></p>
          </div>
        </div>
      </div>
    </>
  );
}

export default AddressCheckbox;
